<template>
  <h1 class="report__display-title">{{ String(text) }}</h1>
</template>
<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style scoped>
.report__display-title {
  font-size: 36px;
  margin-bottom: 0px;
  color: black;
  white-space: pre-line;
}
</style>
